import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import {
  normalizeSocialJsonData,
  socialsList,
} from 'components/coaches-profile/constants'
import InputAdornment from '@material-ui/core/InputAdornment'
import { get } from 'lodash'
import {
  getFieldProps,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const buildEmptySocialData = () =>
  socialsList.map(item => ({
    reference: null,
    type: item.value,
    preferred: true,
  }))

const defineCorrespondingValue = (social, value = []) => {
  const result = (value || []).find(item => item.type === social.value)

  return (
    result || {
      reference: null,
      type: social.value,
      preferred: true,
    }
  )
}

export const Social = () => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { control, errors, setValue, getValues } = useFormContext()

  useEffect(() => {
    if (!getValues('socialJsonData')) {
      setValue('socialJsonData', buildEmptySocialData(), {
        shouldDirty: false,
        shouldValidate: false,
      })
    }
  }, [getValues, setValue])

  const handleSocialChange = (event, social, currentValue) => {
    const updatedSocial = normalizeSocialJsonData(currentValue ?? []).map(
      item =>
        item.type === social.value
          ? {
            ...item,
            reference:
              event.target.value !== ''
                ? `${social.fullURL}${event.target.value}`
                : null,
          }
          : item,
    )

    setValue('socialJsonData', updatedSocial, {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  return (
    <Controller
      name="socialJsonData"
      control={control}
      defaultValue={buildEmptySocialData()}
      render={({ value }) => (
        <Box className={fieldClasses.fieldStack}>
          {socialsList.map((social, index) => {
            const correspondingValue = defineCorrespondingValue(social, value)
            const shortenURL =
              (correspondingValue.reference &&
                correspondingValue.reference.replace(social.fullURL, '')) ||
              ''

            return (
              <TextField
                {...fieldProps}
                key={social.value}
                name={`socialJsonData[${index}].reference`}
                label={social.label}
                type="text"
                value={shortenURL}
                error={!!get(errors, ['socialJsonData', index, 'reference'])}
                helperText={get(errors, [
                  'socialJsonData',
                  index,
                  'reference',
                  'message',
                ])}
                onChange={event => handleSocialChange(event, social, value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      className="input-adornment"
                      style={{ marginRight: 0 }}
                    >
                      {social.placeholder}
                    </InputAdornment>
                  ),
                }}
              />
            )
          })}
        </Box>
      )}
    />
  )
}

export default Social
